import { render, staticRenderFns } from "./BanksConnectionSchool.vue?vue&type=template&id=50417346&scoped=true"
import script from "./BanksConnectionSchool.vue?vue&type=script&lang=js"
export * from "./BanksConnectionSchool.vue?vue&type=script&lang=js"
import style0 from "./BanksConnectionSchool.vue?vue&type=style&index=0&id=50417346&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50417346",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50417346')) {
      api.createRecord('50417346', component.options)
    } else {
      api.reload('50417346', component.options)
    }
    module.hot.accept("./BanksConnectionSchool.vue?vue&type=template&id=50417346&scoped=true", function () {
      api.rerender('50417346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/BanksConnectionSchool.vue"
export default component.exports